var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:'bebas-fallback';size-adjust:75%;src:local(\"Helvetica Neue\")}@font-face{font-display:fallback;font-family:'Inter';font-style:normal;font-weight:600;src:url(" + escape(require("../../public/fonts/Inter/Inter_24pt-SemiBold.ttf")) + ") format(\"truetype\")}\n", ""]);

// exports
